import { createContext, createElement, useContext, useEffect, useMemo, useState } from "react";
import { useSite } from "./site";

export const THEMES = [
  { key: "signature", en: "Landmark Signature", ar: "توقيع لاندمارك", sw: ["#2F4A4F", "#E4472B", "#C9A96E"] },
  { key: "champagne", en: "Champagne Gold", ar: "الذهبي الشمباني", sw: ["#0A0A0A", "#C9A96E", "#F5F1E8"] },
  { key: "emerald", en: "Royal Emerald", ar: "الزمرد الملكي", sw: ["#0F3D33", "#C9A96E", "#F2EFE6"] },
  { key: "desert", en: "Desert Sand", ar: "رمال الصحراء", sw: ["#E9DDC8", "#2B6B66", "#3A2E22"] },
];
const ALL = THEMES.map((t) => t.key);
const Ctx = createContext(null);
const sysMode = () => (window.matchMedia?.("(prefers-color-scheme: light)").matches ? "light" : "dark");

export function applyTheme(theme, mode) {
  const h = document.documentElement;
  h.setAttribute("data-theme", theme);
  h.classList.toggle("dark", mode === "dark");
  h.style.colorScheme = mode;
}

export function ThemeProvider({ children }) {
  const { settings } = useSite();
  const ap = useMemo(() => {
    const en = (settings?.appearance_enabled_themes || []).filter((k) => ALL.includes(k));
    return { default_theme: settings?.appearance_default_theme || "signature", default_mode: settings?.appearance_default_mode || "system", enabled_themes: en.length ? en : ALL };
  }, [settings]);
  const [pick, setPick] = useState(() => localStorage.getItem("lf_theme"));
  const [modePick, setModePick] = useState(() => localStorage.getItem("lf_mode"));
  const [sys, setSys] = useState(sysMode);
  useEffect(() => {
    const mq = window.matchMedia?.("(prefers-color-scheme: light)");
    if (!mq) return undefined;
    const h = () => setSys(sysMode());
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, []);
  const theme = pick && ap.enabled_themes.includes(pick) ? pick : ap.enabled_themes.includes(ap.default_theme) ? ap.default_theme : ap.enabled_themes[0];
  const mode = modePick === "light" || modePick === "dark" ? modePick : ap.default_mode === "system" ? sys : ap.default_mode;
  useEffect(() => { if (settings) localStorage.setItem("lf_appearance", JSON.stringify(ap)); }, [ap, settings]);
  useEffect(() => applyTheme(theme, mode), [theme, mode]);
  const value = {
    theme, mode,
    themes: THEMES.filter((t) => ap.enabled_themes.includes(t.key)),
    setTheme: (t) => { localStorage.setItem("lf_theme", t); setPick(t); },
    toggleMode: () => { const m = mode === "dark" ? "light" : "dark"; localStorage.setItem("lf_mode", m); setModePick(m); },
  };
  return createElement(Ctx.Provider, { value }, children);
}

export const useTheme = () => useContext(Ctx);
